/** Açılır menüdeki dönemler (mobil utils/periodRange.ts ile aynı). */
export const PERIOD_OPTIONS = [
  { key: "today", label: "Bugün" },
  { key: "yesterday", label: "Dün" },
  { key: "thisWeek", label: "Bu hafta" },
  { key: "lastWeek", label: "Geçen hafta" },
  { key: "thisMonth", label: "Bu ay" },
  { key: "lastMonth", label: "Geçen ay" },
];

const pad = (n) => String(n).padStart(2, "0");
export const toLocalDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const dayStart = (y, m, d) => new Date(y, m, d, 0, 0, 0, 0);
const dayEnd = (y, m, d) => new Date(y, m, d, 23, 59, 59, 999);

/**
 * Dönemin tarih aralığı (tarayıcının saat diliminde). Süren dönemler bugünde
 * biter: "Bu hafta" pazartesiden bugüne, "Bu ay" ayın birinden bugüne;
 * geçmiş dönemler tam dönemdir. Hafta pazartesi başlar.
 */
export function periodRange(key, now = new Date()) {
  const y = now.getFullYear();
  const m = now.getMonth();
  const d = now.getDate();
  // Pazartesi 0 … pazar 6.
  const weekday = (now.getDay() + 6) % 7;

  let start;
  let end;
  switch (key) {
    case "yesterday":
      start = dayStart(y, m, d - 1);
      end = dayEnd(y, m, d - 1);
      break;
    case "thisWeek":
      start = dayStart(y, m, d - weekday);
      end = dayEnd(y, m, d);
      break;
    case "lastWeek":
      start = dayStart(y, m, d - weekday - 7);
      end = dayEnd(y, m, d - weekday - 1);
      break;
    case "thisMonth":
      start = dayStart(y, m, 1);
      end = dayEnd(y, m, d);
      break;
    case "lastMonth":
      start = dayStart(y, m - 1, 1);
      // Bu ayın 0. günü: geçen ayın son günü.
      end = dayEnd(y, m, 0);
      break;
    case "today":
    default:
      start = dayStart(y, m, d);
      end = dayEnd(y, m, d);
  }
  return { start, end, startDate: toLocalDate(start), endDate: toLocalDate(end) };
}
